module.exports = __webpack_public_path__ + "static/media/external-link.90a51bf3.svg";